{
  "general": {
    "title": "Jämför alternativ",
    "intro": "En snabb titt på skillnaden mellan community, prenumeration och engångsköp.",
    "tableheader": "Prenumeration",
    "note1": "* Gruppköpalternativ och mängdrabatter finns.",
    "note2": "** Språk som stöds är dansk, deutsch, English, español, suomi, français, italiano, norsk, polski, português (Brasil), pусский, svenska",
    "note3": "*** Kräver ett gratis myboardmaker.com community-konto och är endast avsett för lagring av aktiviteter."
  },
  "columnHeadings": {
    "community": "COMMUNITY",
    "onetime": "ENGÅNGSKÖP*",
    "personal": "PERSONLIG PRENUMERATION",
    "professional": "PROFESSIONELL PRENUMERATION",
    "organization": "VERKSAMHETSPRENUMERATION*"
  },
  "mobileHeadings": {
    "community": "Community",
    "onetime": "Engångsköp*",
    "personal": "Personlig prenumeration",
    "professional": "Professionell prenumeration",
    "organization": "Verksamhetsprenumeration*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Aktiveringar",
    "languages": "Språk**",
    "licensing": "Licensiering",
    "pcsSymbols": "PCS Symbols",
    "templates": "Mallar",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Utföra aktiviteter som instruktör",
    "playActivitiesStudent": "Utföra aktiviteter som elev",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Administration för instruktörer",
    "studentManagement": "Administration av elever",
    "assignStudentActivities": "Tilldela elevaktiviteter",
    "cloudStorage": "Molnlagring",
    "createAndJoin": "Skapa och gå med i grupper",
    "accessCommunity": "Åtkomst till 120k+ gemensamma aktiviteter",
    "shareActivity": "Dela aktiviteter i community",
    "curriculum": "Kursplan och innehåll",
    "activitiesToGo": "Boardmaker Activities to Go",
    "instructionalSolutions": "Instructional Solutions",
    "premiumActivities": "Premiumaktiviteter",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 enheter",
    "unlimited": "Obegränsat",
    "byKey": "Licensnyckel",
    "symbols": "80 000+",
    "templates": "600+",
    "languages": "12",
    "login": "Logga in",
    "yes": "Ja",
    "yesNote": "Ja***",
    "no": "Nej"
  }
}